module.exports = __webpack_public_path__ + "staticcomp/img/share.1e458fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/11/share.jpg
// module id = 87gi
// module chunks = 39